// src/frontend/components/AuthWrapper.tsx
import React from 'react';
import FloatingButton from './FloatingButton';

// The frontend should function normally without any authentication requirements
const AuthWrapper: React.FC = () => {
  return <FloatingButton />;
};

export default AuthWrapper;